import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Route, useLocation,Switch,BrowserRouter as Router } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

import { AppTopbar } from './AppTopbar';
import { AppFooter } from './AppFooter';
import { AppMenu } from './AppMenu';
import { AppConfig } from './AppConfig';

import Dashboard from './components/Dashboard';
import ButtonDemo from './components/ButtonDemo';
import ChartDemo from './components/ChartDemo';
import Documentation from './components/Documentation';
import FileDemo from './components/FileDemo';
import FloatLabelDemo from './components/FloatLabelDemo';
import FormLayoutDemo from './components/FormLayoutDemo';
import InputDemo from './components/InputDemo';
import ListDemo from './components/ListDemo';
import MenuDemo from './components/MenuDemo';
import MessagesDemo from './components/MessagesDemo';
import MiscDemo from './components/MiscDemo';
import OverlayDemo from './components/OverlayDemo';
import MediaDemo from './components/MediaDemo';
import PanelDemo from './components/PanelDemo';
import TableDemo from './components/TableDemo';
import TreeDemo from './components/TreeDemo';
import InvalidStateDemo from './components/InvalidStateDemo';
import BlocksDemo from './components/BlocksDemo';
import IconsDemo from './components/IconsDemo';

import Crud from './pages/Crud';
import EmptyPage from './pages/EmptyPage';
import TimelineDemo from './pages/TimelineDemo';

import PrimeReact from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';

import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import './assets/demo/flags/flags.css';
import './assets/demo/Demos.scss';
import './assets/layout/layout.scss';
import './App.scss';

import { Carousel } from 'primereact/carousel';
import { Galleria } from 'primereact/galleria';

import { ProductService } from './service/ProductService';
import axios from 'axios';

import { Link } from 'react-router-dom';
import { Menubar } from 'primereact/menubar';
import {Dropdown} from 'primereact/dropdown';
import { Button } from 'primereact/button';

import { useHistory } from 'react-router-dom';

var yillar=[];
const App = () => {
    const [layoutMode, setLayoutMode] = useState('static');
    const [layoutColorMode, setLayoutColorMode] = useState('light')
    const [inputStyle, setInputStyle] = useState('outlined');
    const [ripple, setRipple] = useState(true);
    const [staticMenuInactive, setStaticMenuInactive] = useState(false);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
    const copyTooltipRef = useRef();
    const location = useLocation();

    PrimeReact.ripple = true;

    let menuClick = false;
    let mobileTopbarMenuClick = false;


    const [products, setProducts] = useState([]);

    const [data,setData] = useState([]);
    const [haberler,setHaberler] = useState([]);
    const [anasayfaToggle,setAnasayfaToggle] = useState(false);

    const [value7, setValue7] = useState({yil: 2023, ay: 1,yilIsim:"2023/2024"});
    //const [yillar,setYillar] = useState([]);
    const history = useHistory();

    const carouselItemTemplate = (product) => {
        return (
            <div className="product-item">
                <div className="product-item-content">
                    <div className="mb-3">
                        {/*<img src={`assets/demo/images/slider/${product.image}`} alt={product.name} className="product-image" />*/}

                        <img src={"https://www.atakent2.org.tr"+product.link} alt={product.description} className="product-image" />
                    </div>
                    
                </div>
            </div>
        );
    };

    const itemTemplate = (item) => {
        return <img src={"https://www.atakent2.org.tr"+item.link} alt={item.description} style={{ width: '80%',height:'500px', display: 'block' }} />;
    }

    const thumbnailTemplate = (item) => {
        return <img src={item.thumbnailImageSrc} alt={item.alt} style={{ display: 'block', }} />;
    }

    const refresh = () => {
        console.log("asdasd");
        setTimeout(function(){
            setAnasayfaToggle(true);
        }, 500);
        
    }
    


    useEffect(() => {

        //console.log(value7);
        yillar=[];
        //yillar.push({yil:'Tümü',ay:1});

        if (mobileMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }

        if(window.location.href=='http://localhost:3000/#/' || window.location.href=='https://www.atakent2.org.tr/#/'){
            setAnasayfaToggle(true);
        }else{
            setAnasayfaToggle(false);
        }
        
        axios.get('https://www.atakent2.org.tr:4000'+'/api/website/siteyillar/'+'5c21efb41ac54aee578d9bdf')
        .then(json => {
            //console.log(json.data);
            //setYillar(json.data);
            
            //setProducts(json.data);
            for(var i=0;i<json.data.length;i++){
                if(json.data[i].yil===2019){
                    json.data[i].yilIsim='2019/2020';
                }else if(json.data[i].yil===2020){
                    json.data[i].yilIsim='2020/2021';
                }else if(json.data[i].yil===2021){
                    json.data[i].yilIsim='2021/2022';
                }else if(json.data[i].yil===2022){
                    json.data[i].yilIsim='2022/2023';
                }else if(json.data[i].yil===2023){
                    json.data[i].yilIsim='2023/2024';
                }
                yillar.push(json.data[i]);
            }
            if(yillar.length>=5){
                yillar.length=5;
            }
            
        }).catch( error => {
            console.log(error);
        });
       
        
        

        const productService = new ProductService();
        //productService.getProductsSmall().then((products) => setProducts(products));

        //console.log(value7);
        if(value7.yil=='Tümü' || value7.yil=='' || value7==""){
            axios.get('https://www.atakent2.org.tr:4000'+'/api/website/sitebilgiler/'+'5c21efb41ac54aee578d9bdf')
            .then(json => {
                //console.log(json.data);
                setData(json.data);
                setHaberler(json.data.duyurular);
                setProducts(json.data.slider);
                
            }).catch( error => {
                console.log(error);
            });
        }else{
            axios.get('https://www.atakent2.org.tr:4000'+'/api/website/sitebilgiler/'+'5c21efb41ac54aee578d9bdf',{headers:{'ay':value7.ay,'yil':value7.yil}})
            .then(json => {
                //console.log(json.data);
                setData(json.data);
                setHaberler(json.data.duyurular);
                setProducts(json.data.slider);
                
            }).catch( error => {
                console.log(error);
            });
        }

        
        
    }, [mobileMenuActive,anasayfaToggle,window.location.href,value7,yillar]);

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    }

    const onRipple = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value)
    }

    const onLayoutModeChange = (mode) => {
        setLayoutMode(mode)
    }

    const onColorModeChange = (mode) => {
        setLayoutColorMode(mode)
    }

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }

        if (!mobileTopbarMenuClick) {
            setMobileTopbarMenuActive(false);
        }

        mobileTopbarMenuClick = false;
        menuClick = false;
    }

    


    const onSidebarClick = () => {
        menuClick = true;
    }


    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    }
   

    const menu = [
        {
            label: 'Anasayfa',
            items: [{
                label: 'Anasayfa', icon: 'pi pi-fw pi-home', to: '/'
            }]
        },
        {
            label: 'Haberler ve Duyurular', icon: 'pi pi-fw pi-sitemap',
            items: [
                 { label: 'Haberler', icon: 'pi pi-fw pi-id-card', to: '/haberler' },
                
            ]
        },
        {
            label: 'Yönetim',
            items: [
                { label: 'Toplu Yapı Yönetim Kurulu', icon: 'pi pi-fw pi-globe', to: '/yonetim' },
                { label: 'Toplu Yapı Denetim Kurulu', icon: 'pi pi-fw pi-globe', to: '/denetim' },
                { label: 'Toplu Yapı Temsilciler Kurulu', icon: 'pi pi-fw pi-globe', to: '/temsilciler' },
                { label: 'Ada Yönetimi', icon: 'pi pi-fw pi-globe', to: '/ada' },
                { label: 'Blok Yöneticileri', icon: 'pi pi-fw pi-globe', to: '/blok' }
            ]
        },
        {
            label: 'Raporlar',
            items: [
                { label: 'TYY Bütçesi', icon: 'pi pi-fw pi-globe', to: '/tytbutce' },
                { label: 'TYY Denetim Raporları', icon: 'pi pi-fw pi-globe', to: '/tyydenetim' },
                { label: 'Aidat Tablosu', icon: 'pi pi-fw pi-globe', to: '/aidat' },
                
            ]
        },
        {
            label: 'Site Bilgileri',
            items: [
                { label: 'Site Yapısı', icon: 'pi pi-fw pi-globe', to: '/siteyapisi' },
                { label: 'Yönetim Planı', icon: 'pi pi-fw pi-globe', to: '/yonetimplani' },
                
            ]
        },
        {
            label: 'Galeri',
            items: [
                { label: 'Galeri', icon: 'pi pi-fw pi-globe', to: '/galeri' },
                
            ]
        },
        {
            label: 'İletişim',
            items: [
                { label: 'İletişim', icon: 'pi pi-fw pi-globe', to: '/iletisim' },
                
            ]
        },
       
    ];

    const addClass = (element, className) => {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    const removeClass = (element, className) => {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    const wrapperClass = classNames('layout-wrapper', {
        'layout-overlay': layoutMode === 'overlay',
        'layout-static': layoutMode === 'static',
        'layout-static-sidebar-inactive': staticMenuInactive && layoutMode === 'static',
        'layout-overlay-sidebar-active': overlayMenuActive && layoutMode === 'overlay',
        'layout-mobile-sidebar-active': mobileMenuActive,
        'p-input-filled': inputStyle === 'filled',
        'p-ripple-disabled': ripple === false,
        'layout-theme-light': layoutColorMode === 'light'
    });


    

    const nestedMenuitems = [
        {
            label: 'Anasayfa',
            url:'/#'
        },
        {
            label: 'Haberler ve Duyurular',
            url:'/#/haberler',
        },
        {
            label: 'Yönetim',
            url:'/#/yonetim'
        },
        {
            label: 'Raporlar',
            url:'/#/tytbutce'
        },
        {
            label: 'Site Bilgileri',
            url:'/#/siteyapisi'
        },
        {
            label: 'Galeri',
            url:'/#/galeri'
        },
        {
            label: 'İletişim',
            url:'/#/iletisim',
        }
    ];
   
    
    const menubarEndTemplate = () => {
        //console.log(yillar);
        
        return (
            <span className="p-input-icon-left">
                <i className="pi pi-search " />
                <Dropdown style={{width:'100%'}} placeholder="Yıl Seçiniz..." id="dropdown" options={yillar} optionLabel="yilIsim" value={value7} onChange={(e) => {setValue7(e.value);refresh()}}/>
                {/*<Button icon="pi pi-refresh" className="p-button-text" onClick={refresh}></Button>*/}
                
            </span>
        );
    };

    return (
        <div className={wrapperClass} onClick={onWrapperClick}>

            <div className="layout-topbar">
                
            
                <Link to="/" className="layout-topbar-logo" >
                    <img src={layoutColorMode === 'light' ? 'assets/layout/images/logoAtakent.png' : 'assets/layout/images/logoAtakent.png'} alt="logo"/>
                    <span>ATAKENT 2.ETAP<p style={{fontSize:10,marginLeft:20}}>Site Yönetimi Resmi Sitesi</p></span>
                    
                </Link>
                
                <div className="col-8 ml-5" style={{display:'flex',alignItems:'center'}}>
                
                    <Menubar responsive={true} model={nestedMenuitems} end={menubarEndTemplate}></Menubar>
                
                </div>

                <button style={{color:'black',marginLeft:20,borderWidth:2,borderRadius:4,width:'10%',height:40,background:'#2ff5c8',cursor:'pointer'}} onClick={() => history.push('/onlineislemler')}>Online İşlemler</button>
            
            </div>

           { anasayfaToggle ? 
                <div >
                    <div className="grid p-fluid media-demo " style={{marginTop:100,justifyContent:'center'}}>
                        <div style={{width:'100%'}}>
                            <div className="card" style={{backgroundColor:'#e3eff1'}}>
                                {/*<Carousel value={products} numVisible={1} numScroll={1}  itemTemplate={carouselItemTemplate} autoplayInterval={3000}></Carousel>*/}
                                {/*<Galleria value={products} style={{ maxWidth: '1640px' }} changeItemOnIndicatorHover showThumbnails={false} showIndicators item={carouselItemTemplate} />*/}
                                <Galleria value={products} numVisible={5} circular style={{ maxWidth: '100%' }} 
                showItemNavigators showItemNavigatorsOnHover showIndicators changeItemOnIndicatorHover 
                showThumbnails={false} item={itemTemplate} thumbnail={thumbnailTemplate} />
                            </div>
                        </div>
                    </div>
                    <div className="grid p-fluid media-demo " style={{justifyContent:'center'}}>
                        <div style={{width:'100%'}}>
                            <div className="card" style={{backgroundColor:'#e3eff1'}}>
                                {/*<div style={{marginLeft:450}}>
                                    <p style={{fontSize:30}}>Haberler Ve Duyurular</p>
                                </div>*/}
                                <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                                <video width="550" controls>
                                    <source src={require('./uploads/cumhuriyet2023.mp4')} type="video/mp4"/>
                                </video>
                                    {/*
                                        haberler.map((d) => 
                                            <li key={d._id}>
                                                <h5 >{d.tarih}</h5>
                                                <p>{d.baslik}</p>
                                            </li>)
           */}
                                </div>
                                                
                            </div>
                        </div>
                    </div>

                    <div className="grid p-fluid media-demo " >
                        <div style={{width:'100%'}}>
                            <div className="card" style={{width:'100%',height:300,background:'#1b1b7b'}}>
                                <div className='flex flex-row mt-4'>
                                    <div className='flex flex-column col-3 ml-8'>
                                        <p style={{color:'white'}}>Sitemiz</p>
                                        <button style={{color:'white',fontSize:10,background:'#1b1b7b',borderWidth:0,textAlign:'left',cursor:'pointer'}} onClick={() => history.push('/siteyapisi')}>Site Yapısı</button>
                                        <button style={{color:'white',fontSize:10,background:'#1b1b7b',borderWidth:0,textAlign:'left',cursor:'pointer'}} onClick={() => history.push('/yonetimplani')}>Yönetim Planı</button>
                                        <p style={{color:'white',marginTop:100}}>© 2019 Smayd EMC</p>
                                    </div>
                                    <div className='flex flex-column col-3 ml-2'>
                                        <p style={{color:'white'}}>Yönetim</p>
                                        <button style={{color:'white',fontSize:10,background:'#1b1b7b',borderWidth:0,textAlign:'left',cursor:'pointer'}} onClick={() => history.push('/yonetim')}>Toplu Yönetim</button>
                                        <button style={{color:'white',fontSize:10,background:'#1b1b7b',borderWidth:0,textAlign:'left',cursor:'pointer'}} onClick={() => history.push('/ada')}>Ada Yönetim</button>
                                        <button style={{color:'white',fontSize:10,background:'#1b1b7b',borderWidth:0,textAlign:'left',cursor:'pointer'}} onClick={() => history.push('/blok')}>Blok Yönetim</button>
                                    </div>
                                    <div className='flex flex-column col-3 ml-2'>
                                        <p style={{color:'white'}}>Raporlar</p>
                                        <button style={{color:'white',fontSize:10,background:'#1b1b7b',borderWidth:0,textAlign:'left',cursor:'pointer'}} onClick={() => history.push('/tytbutce')}>TYY Bütçesi</button>
                                        <button style={{color:'white',fontSize:10,background:'#1b1b7b',borderWidth:0,textAlign:'left',cursor:'pointer'}} onClick={() => history.push('/tyydenetim')}>TYY Denetim Raporları</button>
                                    </div>
                                    <div className='flex flex-column col-5' style={{marginLeft:-100}}>
                                        <div className='card col-6' style={{background:'#1b1b7b',height:100}}>
                                            <p style={{color:'white'}}>Sosyal Medyada Biz</p>
                                            <button style={{height:40}} ><img style={{height:35}} src={require('./assets/images/icons8-facebook-circled-48.png')} /> </button>
                                            <button style={{marginLeft:10,height:40}} ><img style={{height:35}} src={require('./assets/images/icons8-twitter-48.png')} /> </button>
                                            <button style={{marginLeft:10,height:40}} ><img style={{height:35}} src={require('./assets/images/icons8-instagram-48.png')} /> </button>
                                            <button style={{marginLeft:10,height:40}} ><img style={{height:35}} src={require('./assets/images/icons8-mail-64.png')} /> </button>
                                        </div>
                                        <div className='card col-6' style={{background:'#1b1b7b',height:100}}>
                                            <p style={{color:'white'}}>Aidat Borç Sorgulama ve Ödeme</p>
                                            <button style={{color:'black',marginLeft:100,borderWidth:2,borderRadius:4,height:40,background:'#2ff5c8',cursor:'pointer'}} onClick={() => history.push('/onlineislemler')}>Online İşlemler</button>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
                :
                <div>
                    {<div className="layout-sidebar" onClick={onSidebarClick}>
                        <AppMenu model={menu} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} />
                    </div>}

                    {<div className="layout-main-container">
                        <div className="layout-main">
                            <Route path="/haberler" render={(props) => <ButtonDemo {...props} value={value7} data={data} />} />
                            
                            <Route path="/yonetim" render={(props) => <FormLayoutDemo {...props} value={value7} data={data} />}  />
                            <Route path="/denetim" render={(props) => <InputDemo {...props} value={value7} data={data} />}/>
                            <Route path="/temsilciler" render={(props) => <FloatLabelDemo {...props} value={value7} data={data} />}  />
                            <Route path="/ada" render={(props) => <InvalidStateDemo {...props} value={value7} data={data} />}  />                            
                            <Route path="/blok" render={(props) => <TableDemo {...props} value={value7} data={data} />} />

                            <Route path="/tytbutce" render={(props) => <ListDemo {...props} value={value7} data={data} />} />
                            <Route path="/tyydenetim" render={(props) => <TreeDemo {...props} value={value7} data={data} />} />
                            <Route path="/aidat" render={(props) => <PanelDemo {...props} value={value7} data={data} />} />

                            <Route path="/siteyapisi" render={(props) => <OverlayDemo {...props} value={value7} data={data} />} />
                            <Route path="/yonetimplani" render={(props) => <MiscDemo {...props} value={value7} data={data} />} />

                            <Route path="/galeri" render={(props) => <MessagesDemo {...props} value={value7} data={data} />} />
                            <Route path="/iletisim" render={(props) => <MenuDemo {...props} value={value7} data={data} />} />

                            <Route path="/onlineislemler" render={(props) => <IconsDemo {...props} value={value7} data={data} />} />
                        </div>

                        <AppFooter layoutColorMode={layoutColorMode} />
                    </div>}

                </div>
            }


            

            


            
            {<AppConfig rippleEffect={ripple} onRippleEffect={onRipple} inputStyle={inputStyle} onInputStyleChange={onInputStyleChange}
                layoutMode={layoutMode} onLayoutModeChange={onLayoutModeChange} layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange} />
            }
           

        </div>
    );

}

export default App;
